import { atom } from "jotai";
import { ISubmitFormulierResult } from "../interfaces/submit-formulier-results";

export const klantContactResultAtom = atom<ISubmitFormulierResult | false>(false);
